import React, {Component} from "react";
import {Calculator} from "./Calculator";
import {Col, Row} from "reactstrap";
import PropTypes from "prop-types";
import {Strings} from "./Strings";
import {Constants} from "./Constants";

export class CalculationMessages extends Component {
    render() {
        const inputData = this.props.inputData;

        const showMissingInputMessage = !(inputData.inletPressure !== 0 && inputData.outletPressure !== 0 && inputData.flow !== 0);
        const showBadPressureMessage = Calculator.calcPressureDifference(inputData) === null;
        const showAntiCavitationMessage = Calculator.shouldShowAntiCavitationMessage(inputData);
        const showFlowVelocityMessage = (Calculator.shouldShowFlowVelocityMessage(inputData));
        const showDimensionalAreaMessage = Calculator.shouldShowDimensionalAreaMessage(inputData) && !showAntiCavitationMessage;
        const showFullBoreMessage = inputData.valveBore === Constants.FULL;

        const showOkMessage = !(showMissingInputMessage || showBadPressureMessage || showAntiCavitationMessage || showFlowVelocityMessage || showDimensionalAreaMessage || showFullBoreMessage);

        return <Col className="d-flex flex-column botSpace" lg={this.props.lg}>
            <h2>{Strings.titleCalculationMessages}</h2>
            <div className="block flex-fill">
                {showMissingInputMessage &&
                <Row>
                    <Col xs="auto"><span className="messageDot warning"/></Col>
                    <Col className="noPad">{Strings.calculationMessageMissingInput}</Col>
                </Row>}
                {showBadPressureMessage &&
                <Row>
                    <Col xs="auto"><span className="messageDot warning"/></Col>
                    <Col className="noPad">{Strings.calculationMessageBadPressure}</Col>
                </Row>}
                {showAntiCavitationMessage &&
                <Row>
                    <Col xs="auto"><span className="messageDot warning"/></Col>
                    <Col className="noPad">{Strings.calculationMessageAntiCav}</Col>
                </Row>}
                {showFlowVelocityMessage &&
                <Row>
                    <Col xs="auto"><span className="messageDot warning"/></Col>
                    <Col className="noPad">{Strings.calculationMessageHighFlowVel}</Col>
                </Row>}
                {showDimensionalAreaMessage &&
                <Row>
                    <Col xs="auto"><span className="messageDot warning"/></Col>
                    <Col className="noPad">{Strings.calculationMessageDimensionalArea}</Col>
                </Row>}
                {showFullBoreMessage &&
                <Row>
                    <Col xs="auto"><span className="messageDot warning"/></Col>
                    <Col className="noPad">{Strings.calculationMessageFullBore}</Col>
                </Row>}
                {showOkMessage &&
                <Row>
                    <Col xs="auto"><span className="messageDot success"/></Col>
                    <Col className="noPad">{Strings.calculationMessageOkay}</Col>
                </Row>}
            </div>
        </Col>
    }
}

CalculationMessages.propTypes = {
    inputData: PropTypes.shape({
        flow: PropTypes.number,
        inletPressure: PropTypes.number,
        outletPressure: PropTypes.number,
        valveDimension: PropTypes.number,
        valveBore: PropTypes.number,
        description: PropTypes.string
    }).isRequired
};